// extracted by mini-css-extract-plugin
export default {"container":"ContactIcons_container__612dM","icon":"ContactIcons_icon__rMdpo"};